export var ErrorsEnum;
(function (ErrorsEnum) {
    ErrorsEnum["BAD_INPUT"] = "BAD_INPUT";
    ErrorsEnum["VAULT_ACCOUNT_NOT_FOUND"] = "VAULT_ACCOUNT_NOT_FOUND";
    ErrorsEnum["CURRENCY_NOT_FOUND"] = "CURRENCY_NOT_FOUND";
    ErrorsEnum["CURRENCY_DISABLED"] = "CURRENCY_DISABLED";
    ErrorsEnum["NOT_ENOUGH_BALANCE"] = "NOT_ENOUGH_BALANCE";
    ErrorsEnum["BALANCE_UPDATE_FAILED"] = "BALANCE_UPDATE_FAILED";
    ErrorsEnum["ASSET_NOT_FOUND"] = "ASSET_NOT_FOUND";
    ErrorsEnum["ASSET_CMC_INFO_NOT_FOUND"] = "ASSET_CMC_INFO_NOT_FOUND";
    ErrorsEnum["CRYPTO_TRANSACTION_NOT_FOUND"] = "CRYPTO_TRANSACTION_NOT_FOUND";
    ErrorsEnum["NOT_VALID_REFERRER_CODE"] = "NOT_VALID_REFERRER_CODE";
    ErrorsEnum["ADDRESS_NOT_FOUND"] = "ADDRESS_NOT_FOUND";
    ErrorsEnum["ADDRESS_ALREADY_EXISTS"] = "ADDRESS_ALREADY_EXISTS";
    ErrorsEnum["ADDRESS_LIMIT_REACHED_FOR_THE_ASSET"] = "ADDRESS_LIMIT_REACHED_FOR_THE_ASSET";
    ErrorsEnum["TRANSACTION_NOT_CREATED_BUT_UPDATED"] = "TRANSACTION_NOT_CREATED_BUT_UPDATED";
    ErrorsEnum["TRANSACTION_ALREADY_CREATED"] = "TRANSACTION_ALREADY_CREATED";
    ErrorsEnum["TRANSACTION_LIMIT_EXCEEDED"] = "TRANSACTION_LIMIT_EXCEEDED";
    ErrorsEnum["UNSUPPORTED_CRYPTO"] = "UNSUPPORTED_CRYPTO";
    ErrorsEnum["ASSET_ALREADY_EXISTS"] = "ASSET_ALREADY_EXISTS";
    ErrorsEnum["KYC_DETAILS_ALREADY_EXISTS"] = "KYC_DETAILS_ALREADY_EXISTS";
    ErrorsEnum["KYC_DETAILS_NOT_FOUND"] = "KYC_DETAILS_NOT_FOUND";
    ErrorsEnum["SMS_TWO_FACTOR_NOT_VERIFIED"] = "SMS_TWO_FACTOR_NOT_VERIFIED";
    ErrorsEnum["TWO_FACTOR_NOT_VERIFIED"] = "TWO_FACTOR_NOT_VERIFIED";
    ErrorsEnum["TWO_FA_DISABILITY_NOT_ALLOWED"] = "TWO_FA_DISABILITY_NOT_ALLOWED";
    ErrorsEnum["PAYMENT_NOT_FOUND"] = "PAYMENT_NOT_FOUND";
    ErrorsEnum["BOG_TOKEN_COULD_NOT_GENERATED"] = "BOG_TOKEN_COULD_NOT_GENERATED";
    ErrorsEnum["CARD_NOT_FOUND"] = "CARD_NOT_FOUND";
    ErrorsEnum["UNSUPPORTED_PAYMENT_METHOD"] = "UNSUPPORTED_PAYMENT_METHOD";
    ErrorsEnum["USER_NOT_ELIGIBLE_FOR_ADD_CARD"] = "USER_NOT_ELIGIBLE_FOR_ADD_CARD";
    ErrorsEnum["CARD_PAYMENT_FAILED"] = "CARD_PAYMENT_FAILED";
    ErrorsEnum["CARD_PAYMENT_LIMIT_EXCEEDED"] = "CARD_PAYMENT_LIMIT_EXCEEDED";
    ErrorsEnum["USER_CAN_NOT_ADD_CARD_AT_THIS_TIME"] = "USER_CAN_NOT_ADD_CARD_AT_THIS_TIME";
    ErrorsEnum["USER_CAN_NOT_DEPOSIT_BY_CARD_AT_THIS_TIME"] = "USER_CAN_NOT_DEPOSIT_BY_CARD_AT_THIS_TIME";
    ErrorsEnum["BALANCE_NOT_OPENED"] = "BALANCE_NOT_OPENED";
    ErrorsEnum["BALANCE_ALREADY_EXISTS"] = "BALANCE_ALREADY_EXISTS";
    ErrorsEnum["UNSUPPORTED_TRADE_ACTION"] = "UNSUPPORTED_TRADE_ACTION";
    ErrorsEnum["UNSUPPORTED_TRADE_PAIR"] = "UNSUPPORTED_TRADE_PAIR";
    ErrorsEnum["UNSUPPORTED_ORDER_CRYPTO_DTO"] = "UNSUPPORTED_ORDER_CRYPTO_DTO";
    ErrorsEnum["ASSET_NOT_OPENED"] = "ASSET_NOT_OPENED";
    ErrorsEnum["WITHDRAW_BANK_WIRE_ACTION_DISABLED"] = "WITHDRAW_BANK_WIRE_ACTION_DISABLED";
    ErrorsEnum["DEPOSIT_BANK_WIRE_ACTION_DISABLED"] = "DEPOSIT_BANK_WIRE_ACTION_DISABLED";
    ErrorsEnum["WITHDRAW_CRYPTO_ACTION_DISABLED"] = "WITHDRAW_CRYPTO_ACTION_DISABLED";
    ErrorsEnum["BALANCE_CORRECTION_NOT_FOUND"] = "BALANCE_CORRECTION_NOT_FOUND";
    ErrorsEnum["BANK_WIRE_DEPOSIT_NOT_FOUND"] = "BANK_WIRE_DEPOSIT_NOT_FOUND";
    ErrorsEnum["DOCUMENT_REQUIRED_FOR_BANK_WIRE_DEPOSIT"] = "DOCUMENT_REQUIRED_FOR_BANK_WIRE_DEPOSIT";
    ErrorsEnum["USER_OR_PASSWORD_INCORRECT"] = "USER_OR_PASSWORD_INCORRECT";
    ErrorsEnum["EMAIL_NOT_VERIFIED"] = "EMAIL_NOT_VERIFIED";
    ErrorsEnum["USER_HAS_BEEN_SUSPENDED"] = "USER_HAS_BEEN_SUSPENDED";
    ErrorsEnum["USER_NOT_FOUND"] = "USER_NOT_FOUND";
    ErrorsEnum["USER_DOES_NOT_HAVE_REFERRER_CODE"] = "USER_DOES_NOT_HAVE_REFERRER_CODE";
    ErrorsEnum["INITIATOR_NOT_FOUND"] = "INITIATOR_NOT_FOUND";
    ErrorsEnum["USER_NOT_VERIFIED"] = "USER_NOT_VERIFIED";
    ErrorsEnum["BONUS_ALREADY_ADDED"] = "BONUS_ALREADY_ADDED";
    ErrorsEnum["PASSWORDS_DO_NOT_MATCH"] = "PASSWORDS_DO_NOT_MATCH";
    ErrorsEnum["NEW_PASSWORD_MATCHES_EXISTING_PASSWORD"] = "NEW_PASSWORD_MATCHES_EXISTING_PASSWORD";
    ErrorsEnum["INVALID_TOKEN"] = "INVALID_TOKEN";
    ErrorsEnum["REVOKED_TOKEN"] = "REVOKED_TOKEN";
    ErrorsEnum["INVALID_SECRET"] = "INVALID_SECRET";
    ErrorsEnum["REFERRER_CODE_REQUIRED"] = "REFERRER_CODE_REQUIRED";
    ErrorsEnum["REFERRAL_CATEGORY_NOT_FOUND"] = "REFERRAL_CATEGORY_NOT_FOUND";
    ErrorsEnum["USER_ALREADY_EXIST"] = "USER_ALREADY_EXIST";
    ErrorsEnum["USER_WITH_EMAIL_ALREADY_EXISTS"] = "USER_WITH_EMAIL_ALREADY_EXISTS";
    ErrorsEnum["EMAIL_ALREADY_IN_USE"] = "EMAIL_ALREADY_IN_USE";
    ErrorsEnum["REFERRER_CODE_DOES_NOT_EXIST"] = "REFERRER_CODE_DOES_NOT_EXIST";
    ErrorsEnum["REFERRER_IS_NOT_VERIFIED"] = "REFERRER_IS_NOT_VERIFIED";
    ErrorsEnum["WRONG_VERIFICATION_TOKEN"] = "WRONG_VERIFICATION_TOKEN";
    ErrorsEnum["WRONG_AUTHENTICATION_CODE"] = "WRONG_AUTHENTICATION_CODE";
    ErrorsEnum["NO_USER_FOUND"] = "NO_USER_FOUND";
    ErrorsEnum["PASSWORD_INCORRECT"] = "PASSWORD_INCORRECT";
    ErrorsEnum["INVALID_CREDENTIALS"] = "INVALID_CREDENTIALS";
    ErrorsEnum["NEW_MAIL_MUST_BE_DIFFERENT_FROM_OLD_ONE"] = "NEW_MAIL_MUST_BE_DIFFERENT_FROM_OLD_ONE";
    ErrorsEnum["INCORRECT_CODE"] = "INCORRECT_CODE";
    ErrorsEnum["NEW_PHONE_MUST_BE_DIFFERENT_FROM_OLD_ONE"] = "NEW_PHONE_MUST_BE_DIFFERENT_FROM_OLD_ONE";
    ErrorsEnum["USER_ALREADY_VERIFIED"] = "USER_ALREADY_VERIFIED";
    ErrorsEnum["PHONE_ALREADY_EXISTS"] = "PHONE_ALREADY_EXISTS";
    ErrorsEnum["PHONE_NOT_FOUND"] = "PHONE_NOT_FOUND";
    ErrorsEnum["NO_HEADERS_FOUND"] = "NO_HEADERS_FOUND";
    ErrorsEnum["TWO_FACTOR_NOT_FOUND"] = "TWO_FACTOR_NOT_FOUND";
    ErrorsEnum["TWO_FACTOR_AUTHENTICATION_APP_NAME_NOT_FOUND"] = "TWO_FACTOR_AUTHENTICATION_APP_NAME_NOT_FOUND";
    ErrorsEnum["BALANCE_NOT_FOUND"] = "BALANCE_NOT_FOUND";
    ErrorsEnum["TRADE_NOT_FOUND"] = "TRADE_NOT_FOUND";
    ErrorsEnum["VALID_CREDENTIALS_NOT_PROVIDED"] = "VALID_CREDENTIALS_NOT_PROVIDED";
    ErrorsEnum["APP_VERSION_REQUIRED"] = "APP_VERSION_REQUIRED";
    ErrorsEnum["CLIENT_PLATFORM_REQUIRED"] = "CLIENT_PLATFORM_REQUIRED";
    ErrorsEnum["CLIENT_PLATFORM_INVALID"] = "CLIENT_PLATFORM_INVALID";
    ErrorsEnum["SOURCE_ADDRESS_NOT_FOUND"] = "SOURCE_ADDRESS_NOT_FOUND";
    ErrorsEnum["WITHDRAWAL_EMAIL_DATA_MISSING"] = "WITHDRAWAL_EMAIL_DATA_MISSING";
    ErrorsEnum["DESTINATION_ADDRESS_SHOULD_BE_DIFFERENT"] = "DESTINATION_ADDRESS_SHOULD_BE_DIFFERENT";
    ErrorsEnum["INVALID_RATE"] = "INVALID_RATE";
    ErrorsEnum["INVALID_BANK_CODE"] = "INVALID_BANK_CODE";
    ErrorsEnum["INVALID_STATUS"] = "INVALID_STATUS";
    ErrorsEnum["DESTINATION_ADDRESS_ALREADY_EXISTS"] = "DESTINATION_ADDRESS_ALREADY_EXISTS";
    ErrorsEnum["INVALID_DESTINATION_ADDRESS"] = "INVALID_DESTINATION_ADDRESS";
    ErrorsEnum["DESTINATION_WALLET_ADDRESS_NOT_PROVIDED"] = "DESTINATION_WALLET_ADDRESS_NOT_PROVIDED";
    ErrorsEnum["DESTINATION_ADDRESS_RESTRICTED"] = "DESTINATION_ADDRESS_RESTRICTED";
    ErrorsEnum["INVALID_SWIFT_CODE"] = "INVALID SWIFT CODE";
    ErrorsEnum["INVALID_AMOUNT"] = "INVALID AMOUNT";
    ErrorsEnum["VERIFICATION_NOT_AVAILABLE"] = "VERIFICATION_NOT_AVAILABLE";
    ErrorsEnum["NOT_ENOUGH_LIQUIDITY"] = "NOT_ENOUGH_LIQUIDITY";
    ErrorsEnum["COLLATERAL_NOT_FOUND"] = "COLLATERAL_NOT_FOUND";
    ErrorsEnum["EXCHANGE_RATE_NOT_FOUND"] = "EXCHANGE_RATE_NOT_FOUND";
    ErrorsEnum["EXCHANGE_RATE_INVALID"] = "EXCHANGE_RATE_INVALID";
    ErrorsEnum["EXCHANGE_PAIR_DISABLED"] = "EXCHANGE_PAIR_DISABLED";
    ErrorsEnum["EXCHANGE_COMMISSION_NOT_FOUND"] = "EXCHANGE_COMMISSION_NOT_FOUND";
    ErrorsEnum["EXCHANGE_ENTITY_NOT_FOUND"] = "EXCHANGE_ENTITY_NOT_FOUND";
    ErrorsEnum["EXCHANGE_REJECTED"] = "EXCHANGE_REJECTED";
    ErrorsEnum["INVALID_OPERATION_TYPE"] = "INVALID_OPERATION_TYPE";
    ErrorsEnum["INVALID_USER"] = "INVALID_USER";
    ErrorsEnum["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    ErrorsEnum["DEFAULT_ACCOUNT_NOT_FOUND"] = "DEFAULT_ACCOUNT_NOT_FOUND";
    ErrorsEnum["BONUS_BALANCE_NOT_FOUND"] = "BONUS_BALANCE_NOT_FOUND";
    ErrorsEnum["NO_BONUS_TO_CLAIM"] = "NO_BONUS_TO_CLAIM";
    ErrorsEnum["NETWORK_NOT_FOUND"] = "NETWORK_NOT_FOUND";
    ErrorsEnum["NETWORK_ALREADY_EXISTS"] = "NETWORK_ALREADY_EXISTS";
    ErrorsEnum["ASSET_NETWORK_ALREADY_EXISTS"] = "ASSET_NETWORK_ALREADY_EXISTS";
    ErrorsEnum["UNSUPPORTED_ASSET"] = "UNSUPPORTED_ASSET";
    ErrorsEnum["PRE_REQUEST_EXPIRED"] = "PRE_REQUEST_EXPIRED";
    ErrorsEnum["INVALID_MARKET"] = "INVALID_MARKET";
    ErrorsEnum["BTC_VAULT_ACCOUNT_ID_MISSING"] = "BTC_VAULT_ACCOUNT_ID_MISSING";
    ErrorsEnum["INVALID_WITHDRAWAL_ADDRESS"] = "INVALID_WITHDRAWAL_ADDRESS";
    ErrorsEnum["WITHDRAWAL_ADDRESS_REQUIRED"] = "WITHDRAWAL_ADDRESS_REQUIRED";
    ErrorsEnum["WITHDRAWAL_METHOD_REQUIRED"] = "WITHDRAWAL_METHOD_REQUIRED";
    ErrorsEnum["USER_GROUP_NOT_FOUND"] = "DISCOUNT_GROUP_NOT_FOUND";
    ErrorsEnum["ROLE_NOT_FOUND"] = "ROLE_NOT_FOUND";
    ErrorsEnum["ADMIN_NOT_FOUND"] = "ADMIN_NOT_FOUND";
    ErrorsEnum["AGENT_NOT_FOUND"] = "AGENT_NOT_FOUND";
    ErrorsEnum["FORBIDDEN_RESOURCE"] = "FORBIDDEN_RESOURCE";
    ErrorsEnum["USER_CARD_NOT_FOUND"] = "USER_CARD_NOT_FOUND";
    ErrorsEnum["TRADABLE_PAIR_NOT_FOUND"] = "TRADABLE_PAIR_NOT_FOUND";
    ErrorsEnum["WITHDRAWAL_LIMIT_EXCEEDED"] = "WITHDRAWAL_LIMIT_EXCEEDED";
    ErrorsEnum["LOW_WITHDRAWAL_AMOUNT"] = "LOW_WITHDRAWAL_AMOUNT";
    ErrorsEnum["LOW_AMOUNT"] = "LOW_AMOUNT";
    ErrorsEnum["ASSET_NOT_WITHDRAWABLE"] = "ASSET_NOT_WITHDRAWABLE";
    ErrorsEnum["EXCHANGE_LIMIT_EXCEEDED"] = "EXCHANGE_LIMIT_EXCEEDED";
    ErrorsEnum["KRAKEN_CREDENTIALS_REQUIRED"] = "KRAKEN_CREDENTIALS_REQUIRED";
    ErrorsEnum["BTSE_CREDENTIALS_REQUIRED"] = "BTSE_CREDENTIALS_REQUIRED";
    ErrorsEnum["WHITEBIT_CREDENTIALS_REQUIRED"] = "WHITEBIT_CREDENTIALS_REQUIRED";
    ErrorsEnum["WHITEBIT_ORDER_CANCELED"] = "WHITEBIT_ORDER_CANCELED";
    ErrorsEnum["WHITEBIT_ORDER_NOT_FOUND"] = "WHITEBIT_ORDER_NOT_FOUND";
    ErrorsEnum["FEATURE_POLICY_NOT_FOUND"] = "FEATURE_POLICY_NOT_FOUND";
    ErrorsEnum["FEATURE_POLICY_ALREADY_EXISTS"] = "FEATURE_POLICY_ALREADY_EXISTS";
    ErrorsEnum["LOAN_TYPE_NOT_FOUND"] = "LOAN_TYPE_NOT_FOUND";
    ErrorsEnum["LOAN_CONFIG_NOT_FOUND"] = "LOAN_CONFIG_NOT_FOUND";
    ErrorsEnum["COLLATERAL_ASSET_NOT_SUPPORTED"] = "COLLATERAL_ASSET_NOT_SUPPORTED";
    ErrorsEnum["LOAN_ASSET_NOT_SUPPORTED"] = "LOAN_ASSET_NOT_SUPPORTED";
    ErrorsEnum["INVALID_ORIGINAL_AMOUNT_ASSET"] = "INVALID_ORIGINAL_AMOUNT_ASSET";
    ErrorsEnum["LOAN_TERM_NOT_FOUND"] = "LOAN_TERM_NOT_FOUND";
    ErrorsEnum["LOAN_REQUEST_NOT_FOUND"] = "LOAN_REQUEST_NOT_FOUND";
    ErrorsEnum["LOAN_NOT_FOUND"] = "LOAN_NOT_FOUND";
    ErrorsEnum["LOAN_CONFIG_ALREADY_EXISTS"] = "LOAN_CONFIG_ALREADY_EXISTS";
    ErrorsEnum["LOAN_AMOUNT_LESS_THAN_MINIMUM"] = "LOAN_AMOUNT_LESS_THAN_MINIMUM";
    ErrorsEnum["LOAN_AMOUNT_MORE_THAN_MAXIMUM"] = "LOAN_AMOUNT_MORE_THAN_MAXIMUM";
    ErrorsEnum["LOAN_PAYMENT_MORE_THAN_CURRENT_AMOUNT"] = "LOAN_PAYMENT_MORE_THAN_CURRENT";
    ErrorsEnum["LOAN_PAYMENT_NOT_FOUND"] = "LOAN_PAYMENT_NOT_FOUND";
    ErrorsEnum["INVALID_ORIGINAL_AMOUNT"] = "INVALID_ORIGINAL_AMOUNT";
    ErrorsEnum["INVALID_EXCHANGE_PAIR"] = "INVALID_EXCHANGE_PAIR";
    ErrorsEnum["EXCHANGE_PAIR_POLICY_NOT_FOUND"] = "EXCHANGE_PAIR_POLICY_NOT_FOUND";
    ErrorsEnum["WITHDRAWAL_FEE_NOT_FOUND"] = "WITHDRAWAL_FEE_NOT_FOUND";
    ErrorsEnum["WITHDRAWAL_FEE_ALREADY_EXISTS"] = "WITHDRAWAL_FEE_ALREADY_EXISTS";
    ErrorsEnum["EXCHANGE_FEE_NOT_FOUND"] = "EXCHANGE_FEE_NOT_FOUND";
    ErrorsEnum["INVALID_EXCHANGE_ACTION"] = "INVALID_EXCHANGE_ACTION";
    ErrorsEnum["EXCHANGE_REQUEST_DOES_NOT_EXIST_OR_EXPIRED"] = "EXCHANGE_REQUEST_DOES_NOT_EXIST_OR_EXPIRED";
    ErrorsEnum["TRANSACTION_NOT_FOUND"] = "TRANSACTION_NOT_FOUND";
    ErrorsEnum["EXCHANGE_NOT_FOUND"] = "EXCHANGE_NOT_FOUND";
    ErrorsEnum["NO_ROUNDING_PRECISION"] = "NO_ROUNDING_PRECISION";
    ErrorsEnum["AMOUNT_LESS_THAN_FEE"] = "AMOUNT_LESS_THAN_FEE";
    ErrorsEnum["TRANSACTION_TYPE_NOT_SUPPORTED"] = "TRANSACTION_TYPE_NOT_SUPPORTED";
    ErrorsEnum["MARGIN_ALREADY_EXISTS"] = "MARGIN_ALREADY_EXISTS";
    ErrorsEnum["INVALID_EXCHANGE_METHOD"] = "INVALID_EXCHANGE_METHOD";
    ErrorsEnum["DESTINATION_IBAN_NOT_PROVIDED"] = "DESTINATION_IBAN_NOT_PROVIDED";
    ErrorsEnum["BANK_REQUISITE_NOT_FOUND"] = "BANK_REQUISITE_NOT_FOUND";
    ErrorsEnum["BANK_REQUISITE_NAME_ALREADY_EXISTS"] = "BANK_REQUISITE_NAME_ALREADY_EXISTS";
    ErrorsEnum["BANK_REQUISITE_BELONGS_OTHER_USER"] = "BANK_REQUISITE_BELONGS_OTHER_USER";
    ErrorsEnum["INVALID_BANK_REQUISITE"] = "INVALID_BANK_REQUISITE";
    ErrorsEnum["VERIFIED_BANK_REQUISITE_ALREADY_EXISTS"] = "VERIFIED_BANK_REQUISITE_ALREADY_EXISTS";
    ErrorsEnum["BANK_REQUISITE_REQUIRED"] = "BANK_REQUISITE_REQUIRED";
    ErrorsEnum["BANK_REQUISITE_ALREADY_EXISTS"] = "BANK_REQUISITE_ALREADY_EXISTS";
    ErrorsEnum["COULD_NOT_TRADE_ON_KRAKEN"] = "COULD_NOT_TRADE_ON_KRAKEN";
    ErrorsEnum["KRAKEN_ORDER_CANCELED"] = "KRAKEN_ORDER_CANCELED";
    ErrorsEnum["KRAKEN_ORDER_ALREADY_EXECUTED"] = "KRAKEN_ORDER_ALREADY_EXECUTED";
    ErrorsEnum["KRAKEN_ORDER_NOT_FOUND"] = "KRAKEN_ORDER_NOT_FOUND";
    ErrorsEnum["BTSE_ORDER_CANCELED"] = "BTSE_ORDER_CANCELED";
    ErrorsEnum["COINROUTES_ORDER_CANCELED"] = "COINROUTES_ORDER_CANCELED";
    ErrorsEnum["BYBIT_ORDER_CANCELED"] = "BYBIT_ORDER_CANCELED";
    ErrorsEnum["BYBIT_WITHDRAWAL_FAILED"] = "BYBIT_WITHDRAWAL_FAILED";
    ErrorsEnum["BYBIT_INVALID_CHAIN"] = "BYBIT_INVALID_CHAIN";
    ErrorsEnum["BYBIT_WITHDRAWABLE_AMOUNT_NOT_FOUND"] = "BYBIT_WITHDRAWABLE_AMOUNT_NOT_FOUND";
    ErrorsEnum["BTSE_ORDER_NOT_FOUND"] = "BTSE_ORDER_NOT_FOUND";
    ErrorsEnum["BYBIT_ORDER_NOT_FOUND"] = "BYBIT_ORDER_NOT_FOUND";
    ErrorsEnum["BYBIT_TRANSFER_FAILED"] = "BYBIT_TRANSFER_FAILED";
    ErrorsEnum["BYBIT_CREDENTIALS_REQUIRED"] = "BYBIT_CREDENTIALS_REQUIRED";
    ErrorsEnum["LIQUIDATOR_CREDENTIALS_NOT_FOUND"] = "LIQUIDATOR_CREDENTIALS_NOT_FOUND";
    ErrorsEnum["CONVERT_QUOTE_NOT_FOUND"] = "CONVERT_QUOTE_NOT_FOUND";
    ErrorsEnum["UNSUPPORTED_CONVERT_METHOD"] = "UNSUPPORTED_CONVERT_METHOD";
    ErrorsEnum["NOT_ENOUGH_VOLUME"] = "NOT_ENOUGH_VOLUME";
    ErrorsEnum["NOT_ENOUGH_COST"] = "NOT_ENOUGH_COST";
    ErrorsEnum["BOG_CARD_PAYMENT_NOT_PROCESSED"] = "BOG_CARD_PAYMENT_NOT_PROCESSED";
    ErrorsEnum["INVALID_DESTINATION_BANK"] = "INVALID_DESTINATION_BANK";
    ErrorsEnum["STAKING_TERM_NOT_FOUND"] = "STAKING_TERM_NOT_FOUND";
    ErrorsEnum["NO_ACTIVE_STAKING_TYPES_FOUND"] = "NO_ACTIVE_STAKING_TYPES_FOUND";
    ErrorsEnum["STAKING_AMOUNT_LESS_THAN_MINIMUM"] = "STAKING_AMOUNT_LESS_THAN_MINIMUM";
    ErrorsEnum["STAKING_AMOUNT_MORE_THAN_MAXIMUM"] = "STAKING_AMOUNT_MORE_THAN_MAXIMUM";
    ErrorsEnum["STAKING_NOT_FOUND"] = "STAKING_NOT_FOUND";
    ErrorsEnum["NO_REDEEMABLE_REWARD"] = "NO_REDEEMABLE_REWARD";
    ErrorsEnum["INVALID_REWARD_SELECTION_TYPE"] = "INVALID_REWARD_SELECTION_TYPE";
    ErrorsEnum["INVALID_REWARD_SELECTION_DETAILS"] = "INVALID_REWARD_SELECTION_DETAILS";
    ErrorsEnum["INVALID_REWARD_EVENT_TYPE"] = "INVALID_REWARD_EVENT_TYPE";
    ErrorsEnum["INVALID_REWARD_ACTION_TYPE"] = "INVALID_REWARD_ACTION_TYPE";
    ErrorsEnum["INVALID_REWARD_ACTION_DETAILS"] = "INVALID_REWARD_ACTION_DETAILS";
    ErrorsEnum["STAKING_AUTO_SUB_UNAVAILABLE"] = "STAKING_AUTO_SUB_UNAVAILABLE";
    ErrorsEnum["STAKING_VIOLATION_NOT_ALLOWED"] = "STAKING_VIOLATION_NOT_ALLOWED";
    ErrorsEnum["STAKING_REDEMPTION_NOT_ALLOWED"] = "STAKING_REDEMPTION_NOT_ALLOWED";
    ErrorsEnum["BALANCE_RESERVE_NOT_FOUND"] = "BALANCE_RESERVE_NOT_FOUND";
    ErrorsEnum["BALANCE_RESERVE_ALREADY_EXISTS"] = "BALANCE_RESERVE_ALREADY_EXISTS";
    ErrorsEnum["EMPLOYEE_NOT_FOUND"] = "EMPLOYEE_NOT_FOUND";
    ErrorsEnum["BRANCH_NOT_FOUND"] = "BRANCH_NOT_FOUND";
    ErrorsEnum["FIREBLOCKS_INSUFFICIENT_FUNDS"] = "FIREBLOCKS_INSUFFICIENT_FUNDS";
    ErrorsEnum["BIOMETRIC_TOKEN_STORING_SESSION_EXPIRED"] = "BIOMETRIC_TOKEN_STORING_SESSION_EXPIRED";
    ErrorsEnum["INVALID_BIOMETRIC_SIGNATURE"] = "INVALID_BIOMETRIC_SIGNATURE";
    ErrorsEnum["INVALID_PUBLIC_KEY"] = "INVALID_PUBLIC_KEY";
    ErrorsEnum["INVALID_KEY_TYPE"] = "INVALID_KEY_TYPE";
    ErrorsEnum["INVALID_SESSION_ID"] = "INVALID_SESSION_ID";
    ErrorsEnum["SESSION_NOT_FOUND"] = "SESSION_NOT_FOUND";
    ErrorsEnum["BIOMETRIC_PUBLIC_KEY_NOT_FOUND"] = "BIOMETRIC_PUBLIC_KEY_NOT_FOUND";
    ErrorsEnum["BIOMETRIC_KEY_ALREADY_REGISTERED"] = "BIOMETRIC_KEY_ALREADY_REGISTERED";
    ErrorsEnum["DEVICE_ALREADY_EXISTS"] = "DEVICE_ALREADY_EXISTS";
    ErrorsEnum["DEVICE_NOT_FOUND"] = "DEVICE_NOT_FOUND";
    ErrorsEnum["INVALID_DEVICE_TOKEN"] = "INVALID_DEVICE_TOKEN";
    ErrorsEnum["BIOMETRIC_AUTH_NOT_ACTIVE"] = "BIOMETRIC_AUTH_NOT_ACTIVE";
    ErrorsEnum["DEVICE_INVALID"] = "DEVICE_INVALID";
    ErrorsEnum["DEVICE_NOT_CREATED"] = "DEVICE_NOT_CREATED";
    ErrorsEnum["CANNOT_REVOKE_CURRENT_DEVICE"] = "CANNOT_REVOKE_CURRENT_DEVICE";
    ErrorsEnum["CANNOT_REVOKE_CURRENT_SESSION"] = "CANNOT_REVOKE_CURRENT_SESSION";
    ErrorsEnum["JURISDICTION_NOT_FOUND"] = "JURISDICTION_NOT_FOUND";
    ErrorsEnum["JURISDICTION_INVALID"] = "JURISDICTION_INVALID";
    ErrorsEnum["JURISDICTION_COULD_NOT_CREATED"] = "JURISDICTION_COULD_NOT_CREATED";
    ErrorsEnum["ASSET_JURISDICTION_NOT_FOUND"] = "ASSET_JURISDICTION_NOT_FOUND";
    ErrorsEnum["ASSET_JURISDICTION_ALREADY_EXISTS"] = "ASSET_JURISDICTION_ALREADY_EXISTS";
    ErrorsEnum["COULD_NOT_LOCATE_IP_ADDRESS"] = "COULD_NOT_LOCATE_IP_ADDRESS";
    ErrorsEnum["LIQUIDATOR_NOT_FOUND"] = "LIQUIDATOR_NOT_FOUND";
    ErrorsEnum["INVALID_LIQUIDATOR"] = "INVALID_LIQUIDATOR";
    ErrorsEnum["ACTIVE_LIQUIDATOR_ACCOUNT_NOT_FOUND"] = "ACTIVE_LIQUIDATOR_ACCOUNT_NOT_FOUND";
    ErrorsEnum["LIQUIDATOR_ACCOUNT_NOT_FOUND"] = "LIQUIDATOR_ACCOUNT_NOT_FOUND";
    ErrorsEnum["AVAILABLE_LIQUIDATOR_ACCOUNT_NOT_FOUND"] = "AVAILABLE_LIQUIDATOR_ACCOUNT_NOT_FOUND";
    ErrorsEnum["USER_NOT_ELIGIBLE_FOR_DELETE_ACCOUNT"] = "USER_NOT_ELIGIBLE_FOR_DELETE_ACCOUNT";
    ErrorsEnum["BOT_NOT_FOUND"] = "BOT_NOT_FOUND";
    ErrorsEnum["BOTS_ALREADY_EXISTS"] = "BOTS_ALREADY_EXISTS";
    ErrorsEnum["RULE_NOT_FOUND"] = "RULE_NOT_FOUND";
    ErrorsEnum["SOURCE_WALLET_NOT_ACTIVE"] = "SOURCE_WALLET_NOT_ACTIVE";
    ErrorsEnum["DESTINATION_WALLET_NOT_ACTIVE"] = "DESTINATION_WALLET_NOT_ACTIVE";
    ErrorsEnum["EXTERNAL_WALLET_NOT_FOUND"] = "EXTERNAL_WALLET_NOT_FOUND";
    ErrorsEnum["ONLY_FIREBLOCKS_WALLET_ALLOWED"] = "ONLY_FIREBLOCKS_WALLET_ALLOWED";
    ErrorsEnum["RULE_TRANSACTION_NOT_FOUND"] = "RULE_TRANSACTION_NOT_FOUND";
    ErrorsEnum["RULE_EXECUTION_NOT_FOUND"] = "RULE_EXECUTION_NOT_FOUND";
    ErrorsEnum["EXCHANGE_PAIR_ALREADY_EXISTS"] = "EXCHANGE_PAIR_ALREADY_EXISTS";
    ErrorsEnum["INVALID_SWAP_TASK"] = "INVALID_SWAP_TASK";
    ErrorsEnum["SWAP_INITIATOR_NOT_FOUND"] = "SWAP_INITIATOR_NOT_FOUND";
    ErrorsEnum["SWAP_NOT_FOUND"] = "SWAP_NOT_FOUND";
    ErrorsEnum["SWAP_STATUS_CHANGE_NOT_ALLOWED"] = "SWAP_STATUS_CHANGE_NOT_ALLOWED";
    ErrorsEnum["SWAP_FOR_SAME_ASSETS_NOT_ALLOWED"] = "SWAP_FOR_SAME_ASSETS_NOT_ALLOW";
    ErrorsEnum["SWAP_WITH_GIVEN_DURATION_NOT_ALLOWED"] = "SWAP_WITH_GIVEN_DURATION_NOT_ALLOWED";
    ErrorsEnum["SWAP_DEPOSIT_ALREADY_PROCESSED"] = "SWAP_DEPOSIT_ALREADY_PROCESSED";
    ErrorsEnum["SWAP_EXCHANGE_ALREADY_PROCESSED"] = "SWAP_EXCHANGE_ALREADY_PROCESSED";
    ErrorsEnum["SWAP_WITHDRAW_ALREADY_PROCESSED"] = "SWAP_WITHDRAW_ALREADY_PROCESSED";
    ErrorsEnum["SWAP_TRANCHE_NOT_FOUND"] = "SWAP_TRANCHE_NOT_FOUND";
    ErrorsEnum["ASSET_ALREADY_FAVORITED"] = "ASSET_ALREADY_FAVORITED";
    ErrorsEnum["ASSET_NOT_FAVORITED"] = "ASSET_NOT_FAVORITED";
    ErrorsEnum["CONTACT_ALREADY_EXISTS"] = "CONTACT_ALREADY_EXISTS";
    ErrorsEnum["ARTICLE_NOT_FOUND"] = "ARTICLE_NOT_FOUND";
    ErrorsEnum["ARTICLE_CATEGORY_NOT_FOUND"] = "ARTICLE_CATEGORY_NOT_FOUND";
    ErrorsEnum["INVALID_ARTICLE_CATEGORY"] = "INVALID_ARTICLE_CATEGORY";
    ErrorsEnum["SLUG_ALREADY_IN_USE"] = "SLUG_ALREADY_IN_USE";
    ErrorsEnum["ADVERTISMENT_NOT_FOUND"] = "ADVERTISMENT_NOT_FOUND";
    ErrorsEnum["EMAIL_NOT_SET"] = "EMAIL_NOT_SET";
    ErrorsEnum["PLATFORM_NOT_FOUND"] = "PLATFORM_NOT_FOUND";
    ErrorsEnum["EMAIL_OR_PHONE_REQUIRED"] = "EMAIL_OR_PHONE_REQUIRED";
    ErrorsEnum["INVALID_VERSION_STRING"] = "INVALID_VERSION_STRING";
    ErrorsEnum["COINROUTES_CREDENTIALS_REQUIRED"] = "COINROUTES_CREDENTIALS_REQUIRED";
    ErrorsEnum["COINROUTES_ORDER_NOT_FOUND"] = "COINROUTES_ORDER_NOT_FOUND";
    ErrorsEnum["TBC_CERT_NOT_FOUND"] = "TBC_CERT_NOT_FOUND";
    ErrorsEnum["TBC_WITHDRAWAL_ACCOUNT_NOT_FOUND"] = "TBC_WITHDRAWAL_ACCOUNT_NOT_FOUND";
    ErrorsEnum["CMC_ASSET_INFO_NOT_FOUND"] = "CMC_ASSET_INFO_NOT_FOUND";
    ErrorsEnum["FLITT_SECRET_KEY_NOT_SET"] = "FLITT_SECRET_KEY_NOT_SET";
    ErrorsEnum["FLITT_MERCHANT_ID_NOT_SET"] = "FLITT_MERCHANT_ID_NOT_SET";
    ErrorsEnum["FLITT_CALLBACK_URL_NOT_SET"] = "FLITT_CALLBACK_URL_NOT_SET";
    ErrorsEnum["FLITT_RESPONSE_URL_NOT_SET"] = "FLITT_RESPONSE_URL_NOT_SET";
    ErrorsEnum["FLITT_INVALID_RESPONSE"] = "FLITT_INVALID_RESPONSE";
    ErrorsEnum["ACTIVE_CARD_PAYMENT_MERCHANT_NOT_FOUND"] = "ACTIVE_CARD_PAYMENT_MERCHANT_NOT_FOUND";
    ErrorsEnum["ACTIVE_FIAT_CURRENCY_PROVIDER_NOT_SET"] = "ACTIVE_FIAT_CURRENCY_PROVIDER_NOT_SET";
    ErrorsEnum["ACTIVE_MERCHANT_NOT_FOUND"] = "ACTIVE_MERCHANT_NOT_FOUND";
    ErrorsEnum["KURSIGE_SETTLEMENT_NOT_FOUND"] = "KURSIGE_SETTLEMENT_NOT_FOUND";
    ErrorsEnum["KURSIGE_SETTLEMENT_AMOUNTS_NOT_MATCHED"] = "KURSIGE_SETTLEMENT_AMOUNTS_NOT_MATCHED";
    ErrorsEnum["KURSIGE_SETTLEMENT_AMOUNTS_NOT_DEFINED"] = "KURSIGE_SETTLEMENT_AMOUNTS_NOT_DEFINED";
    ErrorsEnum["KURSIGE_IBAN_NOT_FOUND"] = "KURSIGE_IBAN_NOT_FOUND";
    ErrorsEnum["INVALID_SETTLEMENT_STATUS_FOR_SETTLEMENT_PAYMENT"] = "INVALID_SETTLEMENT_STATUS_FOR_SETTLEMENT_PAYMENT";
    ErrorsEnum["AUTOMATIC_PAYMENT_IS_TURNED_OFF_FOR_THE_SETTLEMENT"] = "AUTOMATIC_PAYMENT_IS_TURNED_OFF_FOR_THE_SETTLEMENT";
    ErrorsEnum["PAYMENT_ALREADY_SENT_FOR_THE_SETTLEMENT"] = "PAYMENT_ALREADY_SENT_FOR_THE_SETTLEMENT";
    ErrorsEnum["INVALID_USD_GEL_EXCHANGE_RATE"] = "INVALID_USD_GEL_EXCHANGE_RATE";
})(ErrorsEnum || (ErrorsEnum = {}));
//# sourceMappingURL=errors.enum.js.map